import { Fragment, PureComponent, ReactNode } from 'react';
import { dotIcon, dropDownArrowIcon, ekaIcon } from '../common/Icons';
import { Patient } from '../../store/types/patient';
import { getAgeString } from '../../store/utils';
import { Popover } from 'antd';
import { LANG_CODE_TO_NAME } from '../prescriptionPad/rightPanel/previewScreen/PreviewPanel';

interface Props {
    patient: Patient;
}

class PatientDetails extends PureComponent<Props> {
    ekaIcon = ekaIcon('w-14 h-16 fill-darwin-accent-bright-blue-800');
    dotIcon = dotIcon();
    dropDownArrow = dropDownArrowIcon();

    render(): ReactNode {
        const { patient } = this.props;
        const { ekaIcon, dotIcon, dropDownArrow } = this;
        const { personal, formData } = patient;
        const { name, phone, age, gender } = personal;
        const { f, l } = name;
        const patientName = [f, l].filter(Boolean).join(' ');
        const { c, n } = phone || {};
        const phoneNumber = [c, n].filter(Boolean).join(' ');
        const uhid = formData?.find((fd) => fd.key === 'uhid')?.value;
        const ageString = getAgeString(
            {
                age: age?.value,
                month: age?.month,
                dob: age?.dob,
            },
            undefined,
            '',
        );
        const filteredFormData = formData?.filter(
            (data) => data.value && String(data.value).trim() && data.key !== 'salutation',
        );
        const abhaId =
            personal['health-ids'] && personal['health-ids'].length !== 0
                ? personal['health-ids'][0]
                : undefined;
        let content = (
            <div className="space-y-4">
                {filteredFormData?.map((data) => (
                    <p>
                        <b>{data.label}:</b>{' '}
                        {data.key === 'lang'
                            ? LANG_CODE_TO_NAME[data.value] || data.value
                            : data.value}
                    </p>
                ))}
                {abhaId && (
                    <p>
                        <b>ABHA ID:</b> {abhaId}
                    </p>
                )}
            </div>
        );
        if (!filteredFormData?.length && !abhaId) content = <p>No details</p>;
        const address = formData?.find((fd) => fd.key === 'paddress')?.value;
        const city = formData?.find((fd) => fd.key === 'city')?.value;
        const state = formData?.find((fd) => fd.key === 'state')?.value;
        const pincode = formData?.find((fd) => fd.key === 'pincode')?.value;
        const addressArray = [
            city && <p key="city">{city}</p>,
            state && <p key="state">{state}</p>,
            pincode && <p key="pincode">{pincode}</p>,
        ];

        return (
            <div className="p-16 flex items-start justify-between text-darwin-neutral_new-800 bg-white">
                <div className="flex items-start space-x-8">
                    <p className="pt-2">{ekaIcon}</p>
                    <div className="space-y-8">
                        <div className="flex items-center space-x-8">
                            <p className="text-14 font-700">{patientName}</p>
                            {(gender || ageString) && (
                                <Fragment>
                                    <p>{dotIcon}</p>
                                    <p className="relative -top-1 capitalize">
                                        {gender}, {ageString}
                                    </p>
                                </Fragment>
                            )}
                        </div>
                        <div className="flex items-center space-x-8">
                            <p>{phoneNumber}</p>
                            {uhid && (
                                <Fragment>
                                    <p>{dotIcon}</p>
                                    <p>{uhid}</p>
                                </Fragment>
                            )}
                            {abhaId && (
                                <Fragment>
                                    <p>{dotIcon}</p>
                                    <p>{abhaId}</p>
                                </Fragment>
                            )}
                            <Popover placement="bottomLeft" content={content} trigger="click">
                                <button className="p-4">{dropDownArrow}</button>
                            </Popover>
                        </div>
                    </div>
                </div>
                <div className="space-y-8">
                    {address && <p>{address}</p>}
                    {addressArray.length > 0 && (
                        <div className="flex items-center justify-end space-x-8">
                            {addressArray.filter(Boolean).map((item, index, array) => (
                                <Fragment key={index}>
                                    {item}
                                    {index < array.length - 1 && <p>{dotIcon}</p>}
                                </Fragment>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

export default PatientDetails;
